import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';

import EllipsisMenu       from 'app/components/common/ellipsis-menu';
import Icon               from 'app/components/common/icon';
import Link               from 'app/components/common/link';
import Meta               from 'app/components/common/meta';
import ClientTimestamp    from 'app/components/common/client-timestamp';
import Pagination         from 'app/components/common/pagination';
import ScrollTable        from 'app/components/common/scroll-table';
import CadminLayout       from 'app/components/company-admin/layout/';
import PageLoading        from 'app/components/layout/page-loading';
import FormsDuck          from 'app/ducks/company-admin/forms';
import UiFormsDuck        from 'app/ducks/company-admin/ui-forms';
import GrantSysDuck       from 'app/ducks/company-admin/grant-system';
import formsHelpers       from 'app/helpers/forms';
import paths              from 'app/paths';
import CadminSlx          from 'app/selectors/company-admin/';
import ModalProgramEdit   from 'app/components/company-admin/grant-system/modal-program-edit';
import RoutingSlx from 'app/selectors/routing';
import AuthSlx from 'app/selectors/auth';
import history from 'app/history';

class CadminPageGrantsMyTasks extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      claimPending: false,
    };
  }

  get currentTab() {
    if (['assigned', 'pool'].includes(this.props.tab)) return this.props.tab;
    return 'assigned';
  }

  async onClickClaim(pt) {
    const {app, task} = pt;
    const employee = this.props.currentUser.employment.employee;

    this.setState({claimPending: true});
    const {grantAssignmentIds} = await this.props.claim(app.id, task.id, employee.id);
    this.setState({claimPending: true});
    const path = paths.cadminGrantAssignment(this.props.company.slug, grantAssignmentIds[0], {backTo: 'app'});
    history.push(path);
  }

  renderTable(assigns, isTodo) {
    const {company} = this.props;
    if (!assigns) return 'loading...';

    if (isTodo && !assigns.length) {
      return <p className="capg-gtasks-yay"><Icon.PartyMusicDanceWoman />You're all caught up!</p>;
    }

    return (
      <table className="ca-box-table capg-gtasks-table">
        <thead>
          <tr>
            <th>Task</th>
            <th>Program</th>
            <th className="right">Assigned</th>
            {!isTodo && <th className="right">Completed</th>}
          </tr>
        </thead>
        <tbody>
          {assigns.map((assign) => {
            const {ass, stage, task, program, app} = assign;
            const appNum = app?.number ? `#${app.number}` : '';
            const taskLabel = `${task?.title || 'Task'} ${appNum}`;
            const isComplete = !!ass.completedTs;
            const color = stage.color;
            const indStyle = isComplete ? {color} : {borderColor: color};
            return (
              <tr key={ass.id}>
                <td>
                  <Link href={paths.cadminGrantAssignment(company.slug, ass.id)} className="pink-hover _flex _align-center _justify-start _gap-6 _fw-bold">
                    <div className={`capg-gtasks-table-ind ${isComplete ? 'complete' : ''}`} style={indStyle}>{isComplete && <Icon.CheckCircle1 style={{color}} />}</div>
                    {taskLabel}
                  </Link>
                </td>
                <td>{program?.title}</td>
                <td className="right">{!!ass.assignedTs && <ClientTimestamp timestamp={ass.assignedTs} />}</td>
                {!isTodo && (
                  <td className="right">{!!ass.completedTs && <ClientTimestamp timestamp={ass.completedTs} />}</td>
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  }

  renderAssigned() {
    if (this.currentTab !== 'assigned') return null;
    const {company, assignsTodo, assignsDone} = this.props;

    return (<>
      <div className="ca-box">
        <div className="ca-box-header">
          <h1 className="ca-box-header-title">To Do</h1>
          <div className="ca-box-header-controls"></div>
        </div>
        <div className="ca-box-body">
          {this.renderTable(assignsTodo, true)}
        </div>
      </div>

      {!!assignsDone?.length && (
        <div className="ca-box">
          <div className="ca-box-header">
            <h1 className="ca-box-header-title">Done</h1>
            <div className="ca-box-header-controls"></div>
          </div>
          <div className="ca-box-body">
            {this.renderTable(assignsDone, false)}
          </div>
        </div>
      )}
    </>);
  }

  renderPoolTable() {
    const {poolTasks, assignsTodo} = this.props;
    if (!poolTasks) return <p>loading...</p>;

    return (
      <table className="ca-box-table">
        <thead>
          <tr>
            <th>Task</th>
            <th>Program</th>
            <th>Waiting Since</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {poolTasks.map((pt) => {
            const {task, app, stage, program} = pt;
            const existing = (assignsTodo || []).find(assign => {
              return (assign.task?.id === task.id) && (assign.app?.id === app.id);
            });
            if (existing) return null;
            const appNum = app?.number ? `#${app.number}` : '';
            const taskLabel = `${task?.title || 'Task'} ${appNum}`;
            const color = stage.color;
            const indStyle = {borderColor: color};
            const dateLabel = moment.unix(app.currentStageAssignedTs).format('MMMM D, YYYY');

            return (
              <tr key={`${task.id}-${app.id}`}>
                <td>
                  <span className="_flex _align-center _justify-start _gap-6 _fw-bold">
                    <div className={`capg-gtasks-table-ind`} style={indStyle}></div>
                    {taskLabel}
                  </span>
                </td>
                <td>{program?.title || ''}</td>
                <td>{dateLabel}</td>
                <td>
                  <button className="btn xs secondary blue" disabled={!!this.state.claimPending} onClick={this.onClickClaim.bind(this, pt)}>Claim Task</button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  }
  renderPool() {
    if (this.currentTab !== 'pool') return null;
    
    return (
      <div className="ca-box">
        <div className="ca-box-header">
          <h1 className="ca-box-header-title">Unassigned Tasks</h1>
          <div className="ca-box-header-controls"></div>
        </div>
        <div className="ca-box-body">
          {this.renderPoolTable()}
        </div>
      </div>
    );
  }

  render() {
    const {company} = this.props;
    if (!company) return <PageLoading />;

    const activeClass = (tab) => (tab === this.currentTab) ? 'active' : '';

    return (
      <CadminLayout company={company} activeItem="grant-my-tasks" className="capg-gtasks">
        <Meta title={`My Tasks | Millie`} />
        <div className="ca-main-head">
          <h1 className="ca-main-head-h1">My Tasks</h1>
          <div className="ca-main-head-actions">
          </div>
        </div>

        <div className="ca-main-tabs">
          <Link href={paths.cadminGrantMyTasks(company.slug, 'assigned')}  className={`ca-main-tabs-tab ${activeClass('assigned')}`}>Assigned to Me</Link>
          <Link href={paths.cadminGrantMyTasks(company.slug, 'pool')}      className={`ca-main-tabs-tab ${activeClass('pool')}`}>Up for Grabs</Link>
        </div>

        {this.renderAssigned()}
        {this.renderPool()}

      </CadminLayout>
    );
  }

}

const stateToProps = (state) => ({
  company: CadminSlx.company(state),
  // assigns: GrantSysDuck.Slx.myAssignments(state),
  assignsTodo: GrantSysDuck.Slx.myAssignmentsTodo(state),
  assignsDone: GrantSysDuck.Slx.myAssignmentsDone(state),
  poolTasks: GrantSysDuck.Slx.poolTasks(state),
  tab: RoutingSlx.params(state).tab,
  currentUser: AuthSlx.currentUser(state),
});
const dispatchToProps = (dispatch) => ({
  claim: (appId, taskId, empId) => dispatch(GrantSysDuck.Ax.assignmentsCreateMany(appId, {taskId, employeeIds: [empId]})),
});

export default connect(stateToProps, dispatchToProps)(CadminPageGrantsMyTasks);
